import { render, staticRenderFns } from "./_NavAdditionalHeaderContent.vue?vue&type=template&id=1098f476&"
import script from "./_NavAdditionalHeaderContent.vue?vue&type=script&lang=js&"
export * from "./_NavAdditionalHeaderContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports